export default {
  title: 'Dieetattributen',
};
